import { SMap } from '@avantia/client-and-server-utilities';
import { getConfig } from 'config/configuration';
import { memo, useRef } from 'react';
import { useAppSelector } from 'store/hooks';

const { paymentPortalUrl } = getConfig();

interface HpFrameProps {
  paymentGuid: string;
  id: number;
  isBraintreeLoading: boolean;
  buttonText: string;
  showPaymentHeader?: boolean;
  paymentTextAnnual?: string;
  subHeadingText?: string;
}

export const paymentIFrameId = 'payment';
const DEFAULT_IFRAME_HEIGHT = 1500;

export const PaymentIFrame = memo(function PaymentIFrame({
  paymentGuid,
  id,
  isBraintreeLoading,
  buttonText,
  showPaymentHeader = true,
  paymentTextAnnual,
  subHeadingText
}: HpFrameProps) {
  const isPaymentSetupError = useAppSelector((state) => state.payments.isPaymentSetupError);
  const iframeHeight = useAppSelector((state) => state.payments.iframeHeight);
  // Stable timestamp: prevents iframe src changing on state-driven re-renders which would reload the iframe
  const iframeTimestamp = useRef(Date.now());
  const username = useAppSelector((state) => state.authentication.email);
  const style: React.CSSProperties = {};
  const formData: SMap<any> = {
    footer: false,
    showPaymentHeader,
    initiatorUrl: document.URL,
    style,
    cardholder: true,
    buttonText,
    paymentTextAnnual,
    subHeadingText,
    username
  };
  let queryString = btoa(JSON.stringify(formData));
  queryString = `config=${encodeURIComponent(queryString)}`;

  const getFrameHeight = (): number => {
    if (isPaymentSetupError) {
      return 250;
    }

    // Hide iframe while loading
    if (isBraintreeLoading) {
      return 0;
    }

    return iframeHeight && !isNaN(iframeHeight) ? iframeHeight : DEFAULT_IFRAME_HEIGHT;
  };

  return (
    <iframe
      data-testid="payment-iframe"
      id={paymentIFrameId + id}
      name={paymentIFrameId}
      title={paymentIFrameId}
      src={`${paymentPortalUrl}/makeapayment/${paymentGuid}?${queryString}&ts=${iframeTimestamp.current}`}
      width="100%"
      height={getFrameHeight()}
      scrolling="no"
      style={{ border: 'none', marginTop: '-16px' }}></iframe>
  );
});
